var map = {
	"./android.png": "8b20",
	"./assign.png": "1f07",
	"./buy.png": "f799",
	"./exclamationMark.png": "2e25",
	"./feedback.png": "d275",
	"./filtrate.png": "061e",
	"./ios.png": "6d5e",
	"./pc.png": "1f01",
	"./retreat.png": "4f00",
	"./sell.png": "3a4b",
	"./star.png": "f604",
	"./starAction.png": "651d",
	"./trigger.png": "ad98",
	"./whiteretreat.png": "b7e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9f0";